import { useQuery } from "@tanstack/react-query";
import { GetDispatchBoardQueueRequest } from "app/data/city-delivery/dispatch-board/models";
import CityDeliveryDiaptchBoardService from "app/data/city-delivery/dispatch-board/cityDeliveryDiaptchBoardService";
import { QUERY_KEYS } from "app/data/common/queryKeys";

export const useDispatchBoardQueue = (requestData: GetDispatchBoardQueueRequest) => {
  const {
    data: dispatchBoardQueueData,
    isLoading,
    isFetching,
    refetch,
    dataUpdatedAt
  } = useQuery({
    queryKey: [QUERY_KEYS.GET_DISPATCH_BOARD_QUEUE, requestData.terminalNumber],
    queryFn: async () => {
      if (requestData?.terminalNumber) {
        return await CityDeliveryDiaptchBoardService
          .getInstance()
          .getDispatchBoardQueue(requestData);
      }
    },
    refetchOnWindowFocus: false,
    refetchInterval: 2 * 60 * 1000, // 2 minutes
    enabled: !!requestData?.terminalNumber,
    retry: true,
  });
  return {
    dispatchBoardQueueData,
    isLoadingDispatchBoardQueue: isLoading || isFetching,
    refetchDispatchBoardQueue: refetch,
    lastUpdated: dataUpdatedAt
  };
}